<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>{{config.phone}}
          <span class="glyphicon glyphicon-envelope"></span>{{config.email}}
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item)">
          <a>
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </a>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <a :to="i.path">{{ i.name }}</a>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 固定顶部导航（PC） -->
    <!-- <div class="header-nav-fixed hidden-xs" :style="{opacity: fixedOpacity, visibility: showFixed ? 'visible' : 'hidden'}">
      <div class="container">
        <div class="header-nav-logo">
          <img src="@/assets/img/logo.png">
        </div>
        <ul class="header-nav-wrapper">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item)"
          >
            <a >
              {{item.name}}
              <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </a>
          </li>
        </ul>
      </div>
    </div> -->
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item)" data-toggle="collapse" data-target="#menu">
            <a :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Header",
  data() {
    return {
      config: config,
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "关于工程豹",
          path: "/companyintroduction",
          children: []
        },
        // {
        //   name: "软件产品",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "Tessai资管后台系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "Tessai客户端系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        {
          name: "新闻中心",
          path: "/newsinformation",
          children: []
        },
        {
          name: "公司招聘",
          path: "/jobchance",
          children: []
        },

        {
          name: "管理系统",
          path: "/contactus",
          children: []
        },
        {
          //name: "986399018@qq.com",
          name: "seo邮箱",
          path: "",
          children: []
        },
      ]
      ,
      showFixed: false,
      fixedOpacity: 0
    };
  },
  methods: {
    navClick(index, { name, path }) {
      // if (name == '下载App') {
      //   // window.open('http://dev-admin.gongcheng1949.com/工程豹.apk')
      //   location.href = 'http://admin.gongcheng1949.com/工程豹.apk';
      //   return
      // }

      if (name == '管理系统') {
        window.open('https://admin.gongcheng1949.com')
        return
      }
      if (name == 'seo邮箱') {
        window.location.href = 'mailto:986399018@qq.com?subject=工程豹seo邮箱';
        return
      }
      this.$router.push(path)
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;

    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    onScroll() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0
      const start = 30
      const fadeRange = 180
      this.showFixed = y > start
      this.fixedOpacity = this.showFixed ? Math.min(1, (y - start) / fadeRange) : 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1000;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav,
#header .header-nav-fixed {
  height: 90px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo,
#header .header-nav-fixed .header-nav-logo {
  width: 300px;
  height: 90px;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img,
#header .header-nav-fixed .header-nav-logo img {
  width: 300px;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav .header-nav-wrapper,
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 90px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li,
#header .header-nav-fixed .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a,
#header .header-nav-fixed .header-nav-wrapper>li>a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i,
#header .header-nav-fixed .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span,
#header .header-nav-fixed .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover,
#header .header-nav-fixed .header-nav-wrapper>li>a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline,
#header .header-nav-fixed .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span,
#header .header-nav-fixed .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a,
#header .header-nav-fixed .header-nav-wrapper>li.active>a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 250px;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}

/* ---------- 新增：防止 <990px 下换行，自动缩小 logo ---------- */
/* 默认：根据 logo 宽度动态限制导航容器宽度，避免挤到下一行 */
#header .header-nav .header-nav-wrapper {
  max-width: none;
  width: calc(100% - 300px);
}

/* 小屏（Bootstrap sm: <992px）缩小 logo，压缩导航边距，保持同一行 */
@media screen and (max-width: 991px) {

  #header .header-nav,
  #header .header-nav-fixed {
    height: 90px;
    padding: 0 8px;
  }

  #header .header-nav .header-nav-logo,
  #header .header-nav-fixed .header-nav-logo {
    width: 220px;
  }

  #header .header-nav .header-nav-logo img,
  #header .header-nav-fixed .header-nav-logo img {
    width: 220px;
  }

  #header .header-nav .header-nav-wrapper,
  #header .header-nav-fixed .header-nav-wrapper {
    width: calc(100% - 220px);
    line-height: 90px;
  }

  #header .header-nav .header-nav-wrapper>li,
  #header .header-nav-fixed .header-nav-wrapper>li {
    margin: 0 8px;
  }
}

/* ---------- 新增：导航右对齐 ---------- */
#header .header-nav .header-nav-wrapper,
#header .header-nav-fixed .header-nav-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

#header .header-nav .header-nav-wrapper>li {
  float: none;
}

/* 固定顶部导航样式 */
#header .header-nav-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 90px;
  background: #fff;
  z-index: 999999;
  transition: opacity .3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue